import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaLocationArrow, FaLongArrowAltLeft, FaSearch, FaSun } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { useEffect, useState } from "react";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
    iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function getDistanceKm(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function openDirections(userLat, userLon, destLat, destLon) {
    const url = `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLon}&destination=${destLat},${destLon}&travelmode=driving`;
    window.open(url, "_blank");
}

const searchCategoryMap = {
    atm: "atm", bank: "atm", hdfc: "atm", sbi: "atm",
    restaurant: "restaurant", cafe: "restaurant", food: "restaurant",
    hospital: "hospital", clinic: "hospital",
    hotel: "hotel", guest: "hotel",
    salon: "salon", spa: "spa",
    temple: "religion", mosque: "religion", church: "religion",
    metro: "metro", subway: "metro",
    bus: "bus",
    petrol: "petrol", fuel: "petrol",
    mall: "mall", shopping: "mall"
};

export default function Nearme() {
    const [city, setCity] = useState("Detecting...");
    const [country, setCountry] = useState("");
    const [lat, setLat] = useState(null);
    const [lon, setLon] = useState(null);
    const [places, setPlaces] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setsearch] = useState("");

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const btnMain = theme === "dark" ? "btn btn-gradientss text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";
    const inputBg = theme === "dark" ? "" : "bg-light text-dark";

    useEffect(() => {
        if (!navigator.geolocation) return;

        navigator.geolocation.getCurrentPosition((position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            setLat(latitude);
            setLon(longitude);

            fetch(
                `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`,
                {
                    headers: {
                        Accept: "application/json",
                        "User-Agent": "TravelHubApp/1.0",
                    },
                }
            )
                .then((res) => res.json())
                .then((data) => {
                    setCity(
                        data.address.city ||
                        data.address.town ||
                        data.address.state ||
                        "Unknown"
                    );
                    setCountry(data.address.country || "");
                });
        });
    }, []);

    function getPlaceCoords(place) {
        if (place.lat && place.lon) {
            return { lat: place.lat, lon: place.lon };
        }
        if (place.center) {
            return { lat: place.center.lat, lon: place.center.lon };
        }
        return null;
    }

    function fetchNearbyPlaces(type = "restaurant") {
        if (!lat || !lon) return;

        setLoading(true);
        setPlaces([]);

        let filter = "";

        if (type === "restaurant") {
            filter = `
      node["amenity"="restaurant"](around:5000,${lat},${lon});
      node["amenity"="cafe"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "hospital") {
            filter = `
      node["amenity"="hospital"](around:5000,${lat},${lon});
      node["amenity"="clinic"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "atm") {
            filter = `
      node["amenity"="atm"](around:5000,${lat},${lon});
      node["amenity"="bank"]["atm"="yes"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "hotel") {
            filter = `
      node["tourism"="hotel"](around:5000,${lat},${lon});
      node["tourism"="guest_house"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "salon") {
            filter = `
      node["shop"="hairdresser"](around:5000,${lat},${lon});
      node["shop"="beauty"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "spa") {
            filter = `
      node["leisure"="spa"](around:5000,${lat},${lon});
      node["shop"="massage"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "religion") {
            filter = `
      node["amenity"="place_of_worship"](around:5000,${lat},${lon});
      node["building"="temple"](around:5000,${lat},${lon});
      node["amenity"="monastery"](around:5000,${lat},${lon});
      node["amenity"="shrine"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "metro") {
            filter = `
      node["railway"="station"]["station"="subway"](around:5000,${lat},${lon});
      node["railway"="subway_entrance"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "bus") {
            filter = `
      node["highway"="bus_stop"](around:5000,${lat},${lon});
      node["amenity"="bus_station"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "petrol") {
            filter = `
      node["amenity"="fuel"](around:5000,${lat},${lon});
      `;
        }

        else if (type === "mall") {
            filter = `
      node["shop"="mall"](around:5000,${lat},${lon});
      node["shop"="department_store"](around:5000,${lat},${lon});
      `;
        }

        const query = `
    [out:json];
    (
      ${filter}
    );
    out center;
    `;

        fetch("https://overpass-api.de/api/interpreter", {
            method: "POST",
            body: query,
        })
            .then((res) => res.json())
            // .then((data) => {
            //     setPlaces(data.elements || []);
            //     setLoading(false);
            // })

            .then((data) => {

                const elements = data.elements || [];

                const sortedPlaces = elements
                    .map((place) => {
                        let coords = null;
                        if (place.lat && place.lon) {
                            coords = { lat: place.lat, lon: place.lon };
                        } else if (place.center) {
                            coords = { lat: place.center.lat, lon: place.center.lon };
                        }
                        if (!coords) return null;
                        const distance = getDistanceKm(
                            lat,
                            lon,
                            coords.lat,
                            coords.lon
                        );
                        return {
                            ...place,
                            distance
                        };
                    })
                    .filter(Boolean)
                    .sort((a, b) => a.distance - b.distance);
                setPlaces(sortedPlaces);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }
    useEffect(() => {
        if (lat && lon) {
            fetchNearbyPlaces("restaurant");
        }
    }, [lat, lon]);
    const filteredPlaces = places.filter((place) => {
        const text = `
        ${place.tags?.name || ""}
        ${place.tags?.brand || ""}
        ${place.tags?.amenity || ""}
        ${place.tags?.shop || ""}
        ${place.tags?.tourism || ""}
        ${place.tags?.railway || ""}
    `.toLowerCase();
        return text.includes(search.toLowerCase());
    });

    return (
        <>
            <title>Near Me – Find Restaurants, ATMs, Hospitals & More Nearby | TravelToolkit</title>
            <meta name="description" content="Find everything near you instantly with TravelToolkit. Discover nearby restaurants, ATMs, hospitals, salons, petrol pumps, malls, and more with real-time location and directions." />
            <meta name="keywords" content="near me places, nearby restaurants, ATM near me, hospitals near me, petrol pump near me, find places nearby, location based search app, nearest places finder" />

            <meta property="og:title" content="Near Me – Find Restaurants, ATMs, Hospitals & More Nearby | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Nearme" />
            <meta property="og:description" content="Find everything near you instantly with TravelToolkit. Discover nearby restaurants, ATMs, hospitals, salons, petrol pumps, malls, and more with real-time location and directions." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Find everything near you instantly with TravelToolkit. Discover nearby restaurants, ATMs, hospitals, salons, petrol pumps, malls, and more with real-time location and directions." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>Near Me</h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        <div className="input-group mb-4">
                            <span className={`input-group-text ${inputBg}`}>
                                <FaSearch />
                            </span>
                            <input
                                type="text"
                                className={`form-control ${inputBg}`}
                                placeholder="Search places (ATM, temple, cafe...)"
                                value={search}
                                onChange={(e) => {
                                    const value = e.target.value.toLowerCase();
                                    setsearch(value);
                                    const category = Object.keys(searchCategoryMap).find(key =>
                                        value.includes(key)
                                    );
                                    if (category) {
                                        fetchNearbyPlaces(searchCategoryMap[category]);
                                    }
                                }} />
                        </div>
                        {lat && lon && (
                            <MapContainer center={[lat, lon]} zoom={13} style={{ height: "240px", borderRadius: "14px" }}>
                                <TileLayer attribution="&copy; OpenStreetMap contributors" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                {filteredPlaces.map((place) => {
                                    const coords = getPlaceCoords(place);
                                    if (!coords) return null;
                                    return (
                                        <Marker key={place.id} position={[coords.lat, coords.lon]}>
                                            <Popup>
                                                <strong>{place.tags?.name || place.tags?.brand || place.tags?.operator || "Nearby Place"}</strong>
                                                <br />
                                                {place.tags?.amenity || place.tags?.shop || place.tags?.tourism || place.tags?.railway}
                                            </Popup>
                                        </Marker>
                                    );
                                })}
                            </MapContainer>
                        )}
                        <div className="d-flex flex-wrap gap-2 my-3">
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("restaurant")}>🍽 Restaurant</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("hospital")}>🏥 Hospital</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("atm")}>🏧 ATM</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("hotel")}>🏨 Hotel</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("salon")}>💇 Salon</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("spa")}>💆 Spa</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("religion")}>🛕 Religious</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("metro")}>🚇 Metro</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("bus")}>🚌 Bus</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("petrol")}>⛽ Petrol</button>
                            <button className={btnMain} onClick={() => fetchNearbyPlaces("mall")}>🛍 Mall</button>
                        </div>
                        {loading && (
                            <div className={`text-center ${textColor}`}>Loading places...</div>
                        )}

                        {!loading && filteredPlaces.length === 0 && (
                            <div className={`text-center ${textColor}`}>No places found nearby</div>
                        )}
                        {filteredPlaces.map((place) => {
                            const coords = getPlaceCoords(place);
                            if (!coords) return null;
                            const distance = place.distance.toFixed(2);
                            return (
                                <div key={place.id} className={`card ${cardBg} p-3 mb-2 d-flex justify-content-between flex-row align-items-center`}>
                                    <div>
                                        <h6>{place.tags?.name || place.tags?.brand || place.tags?.amenity || place.tags?.shop || place.tags?.tourism || place.tags?.railway || "Nearby Place"} </h6>
                                        <small>{place.tags?.amenity || place.tags?.tourism}</small>
                                        <div className="small">📍 {distance} km away</div>
                                    </div>
                                    <button className={btnMain} onClick={() =>
                                        openDirections(lat, lon, coords.lat, coords.lon)}>
                                        <FaLocationArrow />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}